<template>
  <v-flex xs5 lg2>
    <v-treeview
      :active.sync="active"
      :items="studentsByClass"
      :open.sync="open"
      activatable
      active-class="primary--text"
      open-on-click
      transition
    >
      <v-icon
        v-if="!item.children"
        slot="prepend"
        slot-scope="{ item, active }"
        :color="active ? 'primary' : item.sentAt ? 'green' : 'red'"
      >{{item.sentAt ? 'check' : 'close'}}</v-icon>
    </v-treeview>
  </v-flex>
</template>

<script>
import { uniqBy, map } from "lodash";

export default {
  props: ["students", "setOpen", "setActive"],
  data: () => ({
    open: [],
    active: []
  }),
  watch: {
    active: function(active) {
      this.setActive(active);
    },
    open: function(open) {
      this.setOpen(open);
    }
  },
  computed: {
    studentsByClass: function() {
      const classes = map(uniqBy(this.students, "class"), student => ({
        name: student.class || "n/a",
        id: student.class || "n/a",
        children: []
      }));
      this.students.map(student => {
        classes
          .find(
            c =>
              c.name === student.class ||
              (student.class === null && c.name === "n/a")
          )
          .children.push({
            ...student,
            name: `${student.lastName} ${student.firstName}`,
            id: student._id
          });
      });

      classes.map((c) => {
        c.name = `${c.name} (${c.children.length})`
      })

      return classes.sort((a, b) => a.name.localeCompare(b.name));
    }
  }
};
</script>

